import React, { Component } from 'react';
import { UnifiedLayout } from '../../layouts/UnifiedLayout/UnifiedLayout';
import { DocumentTitle } from '../../components';
import LoginForm from './form/LoginForm';

export class Login extends Component {
  render() {
    return (
      <DocumentTitle title={'SolarWinds Cloud'}>
        <div data-test-page-name="login">
          <UnifiedLayout>
            <LoginForm />
          </UnifiedLayout>
        </div>
      </DocumentTitle>
    );
  }
}

export default Login;
